import { Box, customStyled, Flex } from '@mafc/trolly';
import MQ from 'theme/breakpoints';

export const ProductImage = customStyled(Box)(() => ({
  position: 'relative',
  width: '56px',
  height: '56px',
  maxWidth: '56px',
  flexBasis: '20%',
}));

export const ImageWrapper = customStyled(Box)<{ outOfStock: boolean }>(({ outOfStock }) => ({
  filter: outOfStock ? 'grayscale(100%)' : 'none',
}));

export const ExpressNowTag = customStyled(Flex)<{ outOfStock: boolean }>(({ outOfStock }) => ({
  position: 'absolute',
  bottom: '-15px',
  left: '50%',
  transform: 'translateX(-50%)',
  filter: outOfStock ? 'grayscale(100%)' : 'none',
}));

export const OOSTag = customStyled(Flex)`
  position: absolute;
  top: 21px;
  left: -16px;
  ${MQ[2]} {
    left: -14px;
  }
`;
